// extracted by mini-css-extract-plugin
export default {"wrapper":"RandomPackages_wrapper__eNEDw","card":"RandomPackages_card__CELMK"};